import style from './index.module.scss';
import arbitrage from '../../../assets/labels/arbitrage.png';
import babyhand from '../../../assets/labels/babyhand.png';
import beachhand from '../../../assets/labels/beachhand.png';
import feminisation from '../../../assets/labels/feminisation.png';
import formateur from '../../../assets/labels/formateur.png';
import handa4 from '../../../assets/labels/handa4.png';
import handensemble from '../../../assets/labels/handensemble.png';
import handfit from '../../../assets/labels/handfit.png';
import integriteCitoyenne from '../../../assets/labels/integrite-citoyenne.png';

const ClubLabels = ({ listFiltered }) => {
    return (
        <div className={style.listLabels}>
            {listFiltered &&
                listFiltered.map((label, key) => {
                    let returnValue = { image: undefined, label: '' };

                    switch (label[0]) {
                        case 'arbitrage':
                            returnValue.image = arbitrage;
                            returnValue.label = 'Arbitrage';
                            break;
                        case 'beach_hand':
                            returnValue.image = beachhand;
                            returnValue.label = 'BeachHandball';
                            break;
                        case 'baby_hand':
                            returnValue.image = babyhand;
                            returnValue.label = 'BabyHand';
                            break;
                        case 'feminisation':
                            returnValue.image = feminisation;
                            returnValue.label = 'Féminisation';
                            break;
                        case 'formateur':
                            returnValue.image = formateur;
                            returnValue.label = 'Club Formateur';
                            break;
                        case 'hand_a_4':
                            returnValue.image = handa4;
                            returnValue.label = 'Hand à 4';
                            break;
                        case 'hand_ensemble':
                            returnValue.image = handensemble;
                            returnValue.label = 'HandEnsemble';
                            break;
                        case 'hand_fit':
                            returnValue.image = handfit;
                            returnValue.label = 'Handfit';
                            break;
                        case 'integrite_citoyenne':
                            returnValue.image = integriteCitoyenne;
                            returnValue.label = 'Intégrité Citoyenneté';
                            break;
                        default:
                            break;
                    }

                    return (
                        <div key={key} className={style.label}>
                            <img
                                src={returnValue.image}
                                alt={returnValue.label}
                                key={key}
                            />
                            <p>{returnValue.label}</p>
                        </div>
                    );
                })}
        </div>
    );
};

export default ClubLabels;
